<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_131_7406)">
      <path
        d="M10.9446 9.76822H10.3251L10.1056 9.55651C10.874 8.66261 11.3366 7.50211 11.3366 6.23967C11.3366 3.42468 9.05485 1.14288 6.23986 1.14288C3.42486 1.14288 1.14307 3.42468 1.14307 6.23967C1.14307 9.05467 3.42486 11.3365 6.23986 11.3365C7.50229 11.3365 8.66279 10.8738 9.55669 10.1054L9.7684 10.3249V10.9444L13.689 14.8572L14.8574 13.6888L10.9446 9.76822ZM6.23986 9.76822C4.28739 9.76822 2.71131 8.19214 2.71131 6.23967C2.71131 4.28721 4.28739 2.71113 6.23986 2.71113C8.19232 2.71113 9.7684 4.28721 9.7684 6.23967C9.7684 8.19214 8.19232 9.76822 6.23986 9.76822Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
<script lang="ts" setup></script>
